import { roundNumber } from 'shared/utils/helpers/roundNumber';
import { getVatRateAmount } from './getVatRateAmount';

export const getPriceWithVat = (price: number, vatRatePercent = 0): number => {
  if (!vatRatePercent) {
    return roundNumber(price);
  }

  return roundNumber(price + getVatRateAmount(price, vatRatePercent));
};
